import { useState } from "react";
import { Reveal } from "@/components/site/motion";
import { screen, roman } from "@/data/screens";

const ITEMS = ["dashboard", "transactions", "split", "funds", "report"].map(screen);

export const Showcase = () => {
  const [active, setActive] = useState(0);
  return (
    <section className="py-20 sm:py-28 lg:py-32" data-testid="showcase-section">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <p className="eyebrow">Inside Grace Treasury</p>
          <h2 className="h2 mt-4">From Sunday's offering to the board report.</h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600">Record gifts and expenses, split deposits across funds, follow every fund balance, and print a Treasurer's Report each month, all in one place.</p>
        </Reveal>
        <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:gap-14">
          <Reveal className="lg:col-span-4">
            <ol className="border-t border-slate-200" role="tablist">
              {ITEMS.map((s, i) => (
                <li key={s.id} className="border-b border-slate-200">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={active === i}
                    onClick={() => setActive(i)}
                    onMouseEnter={() => setActive(i)}
                    className="group flex w-full items-baseline gap-5 py-5 text-left"
                    data-testid={`showcase-tab-${s.id}`}
                  >
                    <span className={`w-8 font-mono text-xs ${active === i ? "text-[#8a6a2f]" : "text-slate-500"}`}>{roman(i + 1)}</span>
                    <span className="flex-1">
                      <span className={`block font-display text-2xl transition-colors ${active === i ? "text-navy" : "text-slate-500 group-hover:text-navy"}`}>{s.title}</span>
                      <span className={`grid transition-all duration-500 ${active === i ? "mt-2 grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                        <span className="overflow-hidden text-sm leading-relaxed text-slate-600">{s.body}</span>
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ol>
          </Reveal>
          <Reveal className="lg:col-span-8" delay={0.1}>
            <div className="exhibit-frame">
              <div className="relative aspect-[16/10] overflow-hidden border border-slate-200 bg-white" data-testid="showcase-frame">
                {ITEMS.map((s, i) => (
                  <img
                    key={s.id}
                    src={s.img}
                    alt={`Grace Treasury: ${s.title}`}
                    loading="lazy"
                    className={`absolute inset-0 h-full w-full object-cover object-top transition-all duration-700 ${active === i ? "scale-100 opacity-100" : "scale-[1.02] opacity-0"}`}
                  />
                ))}
              </div>
              <div className="mt-3 flex items-baseline justify-between px-1">
                <span className="eyebrow">Plate {roman(active + 1)}</span>
                <span className="text-xs text-slate-600" data-testid="showcase-active-label">{ITEMS[active].label}</span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
